(function(){
    angular
        .module('appback')
        .directive('ngSelect2', select2);

        select2.$inject = ['$timeout','batchselect2Service'];
        function select2($timeout,batchselect2Service){
            return {
              require: 'ngModel',
              scope:{
                ngModel:"=",
                options:"=",
                extraparams : "=",
                removesearcher : "="
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {

                  //console.log("select2 ",$attrs.name);
                  var options = {};
                  if(scope.options){
                    options = angular.copy(scope.options);
                    //console.log(scope);
                    if(scope.extraparams){
                      var datavar = options.ajax.data({});
                      //console.log(scope.extraparams);
                      options.ajax.data = function(params){
                        datavar.q = params.term;
                        datavar.page = params.page;
                        if($attrs.campos){
                          datavar.field = $attrs.campos;
                        }
                        var objectMerge = angular.merge({}, datavar, scope.extraparams);
                        return objectMerge;
                      }
                    }
                  }
                  //console.log(options);
                  var $element = $(element);
                  if(scope.removesearcher===true){
                    options.minimumResultsForSearch = -1;
                  }

                  $element.select2(options);//.val([{"id":"10","text":"value"}]).trigger("change");

                    
                    
                    $element.on("select2:open", function (evt) {
                        //console.log("select2open");
                      
                      $timeout(function(){
                         document.querySelector('.select2-container--open .select2-search__field').focus();
                      });

        
                    });
                    $element.on("change.select2", function (evt) {
                    });
                    /*$element.on("change", function (evt) {
                      console.log("CHANGE");
                    })*/
                    $element.on("select2:select", function (evt) {
                        var elementVar = evt.params.data.element;
                        var $elementVar = $(elementVar);
                        ngModel.$setViewValue($element.val());
                       
                      });

                    function orderSortedValues() {
                        var value = ''
                        $element.parent().find("ul.select2-selection__rendered").children("li[title]").each(function(i, obj){

                            var elM = $element.children('option').filter(function () { return $(this).html() == obj.title });
                            moveElementToEndOfParent(elM)
                        });
                    };
                   function moveElementToEndOfParent(elM) {
                        var parent = elM.parent();
                        elM.detach();
                        parent.append(elM);
                    };

                    function actualizarElementos(){
                      $element.select2(options).trigger('change.select2');
                      if(typeof $attrs.multiple!='undefined'){
                        var ul = $element.parent().find("ul.select2-selection__rendered");
                        ul.sortable({
                            placeholder : 'ui-state-highlight',
                            items: '> li.select2-selection__choice',
                            tolerance   : 'pointer',
                            update: function() {
                              orderSortedValues();
                             
                                $element.trigger("change");
                            }
                        });
                      }
                    }

                    function cambiando(){
                      //console.log("cambiando");
                      if(scope.ngModel==""){
                        $element.trigger('change.select2');
                      }else{
                        var texto = $element.find("option:selected").text();
                        if(!texto && scope.ngModel && $attrs.campos){
                          if(Array.isArray(ngModel.$viewValue)){
                            for(var cont=0;cont<ngModel.$viewValue.length;cont++){
                              if(ngModel.$viewValue[cont]!=0){
                                var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue[cont]).text("Cargando..");
                                $element.append($newOption).trigger('change.select2');
                              }
                            }
                          }else{
                             if(ngModel.$viewValue!=0){
                               var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue).text("Cargando..");
                               $element.append($newOption).trigger('change.select2');
                             }
                          }
                          if(scope.ngModel!=0){
                            var objReq = { campo:$attrs.campos,nodetype:$attrs.nodetype,value:scope.ngModel}
                            batchselect2Service.addId(objReq).then(function(data) {
                              //console.log("ENTRO A LA PETI");
                                for(var cont=0;cont<data.length;cont++){
                                  //console.log("data",data);
                                  //console.log("scope.ngModel",scope.ngModel);
                                  if($attrs.nodetype==data[cont].nodetype && $attrs.campos==data[cont].campo){
                                    
                                    $element.find("option[value='"+data[cont].id+"']").text(data[cont].text);
                                    //console.log("ENTRO ACTUALIZANDO");
                                  }
                                }
                               actualizarElementos();

                            }, function(error) {
                                console.error('Error obteniendo datos:', error);
                            });
                            
                          }
                        }else{
                          $element.trigger('change.select2');
                          if(typeof $attrs.multiple!='undefined'){
                            var ul = $element.parent().find("ul.select2-selection__rendered");
                            ul.sortable({
                                placeholder : 'ui-state-highlight',
                                items: '> li.select2-selection__choice',
                                tolerance   : 'pointer',
                                update: function() {
                                  orderSortedValues();
                                    /*$(ul.find('.select2-selection__choice').get().reverse()).each(function() { 
                                        var id = $(this).data('data').id;
                                        var option = $element.find('option[value="' + id + '"]')[0];
                                        $($element).prepend(option);
                                        //$element.trigger("change");
                                    });*/
                                    $element.trigger("change");
                                }
                            });
                          }
                        }
                        
                      }
                    }
                    cambiando();
                    scope.$watch('ngModel', cambiando, true);

                     //console.log("LIST");
                 
                });
            }
          }
      }
})();